import styled from "styled-components";

export const TextoConteudo = styled.span`
  color: ${({ theme }) => theme.color.feedback.error};
  margin: 0;
`;

export default styled.div`
  svg {
    color: ${({ theme }) => theme.color.feedback.error} !important;
  }
  .Alert__Content {
    padding: 0;
  }
`;
